<template>
    <div class="ly-summary-panel">
        <div class="ly-s-p-title">
            {{attrs.title}}
        </div>
        <!-- 顶部汇总数据 start -->
        <div class="ly-s-p-number">
            <ly-show :value="value" :config="attrs.top" :is-show-icon="false"></ly-show>
        </div>
        <!-- 顶部汇总数据  end  -->
        <!-- 中间同期  start-->
        <div class="ly-s-p-old ly-s-p-title">
            <ly-show :value="value" :config="attrs.middle"></ly-show>
        </div>
        <!-- 中间同期  end -->
        <Divider />
        <div class="ly-s-p-bottom">
            <ly-show :value="value" :config="attrs.bottom"></ly-show>
        </div>
    </div>
</template>
<script>
    /**
     * 汇总面板
     */
    import LyShow from './show'
    export default {
        name: 'LySummaryPanel',
        props: {
            value: {
                type: [Object, String],
                default: _ => new Object()
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        components: {
            LyShow
        }
    }
</script>

<style>
    .ly-summary-panel {
        padding: 20px;
        border: 1px solid rgb(233,233,233);
        border-radius: 5px;
        background-color: #fff;
    }
    .ly-summary-panel > .ivu-divider {
        margin: 15px 0;
    }
    .ly-s-p-title {
        color: raba(0, 0, 0, .4);
        font-size: 14px;
    }
    .ly-s-p-number {
        color: rgba(0, 0, 0, .8);
        font-size: 30px;
        font-weight: bold;
        padding: 5px 0 10px;
    }
    .ly-s-p-number span{
        font-size: 16px;
        display: inline-block;
        margin-right: 3px;
        line-height: 16px;
    }
    .ly-s-p-bottom {
        color: rgba(0, 0, 0, .6);
        font-size: 14px;
    }
    .ly-s-p-bottom span {
        font-size: 12px;    
        line-height: 12px;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/summary-panel/src/index.vue